import * as React from "react";
import type { AnalysisWordChange } from "../../agreement";

export type DiffTextProps = {
  changes: AnalysisWordChange[];
  className?: string;
  dimmed?: boolean;
};

export const DiffText: React.FC<DiffTextProps> = ({ changes, className, dimmed }) => {
  return (
    <p
      className={`ai-analysis__diff${dimmed ? " ai-analysis__dimmed" : ""}${className ? ` ${className}` : ""}`}
      aria-busy={dimmed}
    >
      {changes.map((change, i) => {
        if (change.type === "equal") {
          return <span key={i}>{change.text}</span>;
        }
        if (change.type === "deletion") {
          return (
            <span key={i} className="ai-analysis__diff-removed">
              {change.text}
            </span>
          );
        }
        if (change.type === "insertion") {
          return (
            <span key={i} className="ai-analysis__diff-added">
              {change.text}
            </span>
          );
        }
        return null;
      })}
    </p>
  );
};
